import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Table from '../components/atoms/Table';
import IcoClose from '../assets/images/button/ico-pop-close.svg';
import { getAddress } from '../hooks/RQuery/service/address';
import objectPoint from '../ol/Object/ObjectPoint';
import Button from '../components/atoms/Button';
import { exportXlsx } from '../util/xlsx';
import { transYMD } from '../util/scripts';
export const PopupSt = {
  Wrap: styled.div`
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 2;
    width: calc(100% - 400px);
    background: #fff;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 -7px 12px 0 #00000040;
    max-height: 396px;
    transform: translateX(-50%);
  `,
  Inner: styled.div`
    padding: 20px;
  `,
  Close: styled.button`
    width: 24px;
    height: 24px;
    background: url(${IcoClose}) no-repeat center;
  `,
};
const PopupPointList = ({ points, objectPoint, setPoints }) => {
  //명칭 및 번호 return
  const nameReturn = (feature) => {
    //  if (String(prop.getId()).split('.')[0] === 'dt_d007') {
    if (feature.getProperties().properties.BASE_NAME === '지적도근점') {
      return feature.getProperties()?.properties.DOGEUN_POI;
      //  } else if (String(prop.getId()).split('.')[0] === 'dt_d008') {
    } else if (feature.getProperties().properties.BASE_NAME === '지적삼각보조점') {
      return feature.getProperties()?.properties.TRAG_ASSTC;
      //  } else if (String(prop.getId()).split('.')[0] === 'dt_d009') {
    } else if (feature.getProperties().properties.BASE_NAME === '지적삼각점') {
      return feature.getProperties()?.properties.TRAG_POINT;
    }
  };

  //닫기 버튼
  const onClose = () => {
    setPoints([]);
    objectPoint?.onClickPointClear();
  };

  //행 삭제
  const onClick = (feature) => {
    const newArr = [...points];
    setPoints(newArr.filter((i) => i !== feature));
    objectPoint?.onRemoveRow(feature);
  };

  const onExportXlsx = () => {
    exportXlsx(points);
  };
  return (
    <PopupSt.Wrap style={{ minWidth: 1200 }}>
      <PopupSt.Inner>
        <div style={{ position: 'absolute', right: 20, top: 20, textAlign: 'right', marginBottom: 6, display: 'flex', alignItems: 'center' }}>
          <Button text={'엑셀 다운로드'} onClick={onExportXlsx} $colorType={'peacock'} width={120} style={{ marginRight: 10 }} />
          <PopupSt.Close type={'button'} onClick={onClose}>
            <span className={'hidden'}>닫기</span>
          </PopupSt.Close>
        </div>

        <p style={{ marginBottom: 6 }}>
          ※ 아래 내용은 참고용으로 증명용 지적측량기준점성과 등본을 시군구 종합민원실에서 발급받아 확인하시기 바랍니다.
          <br />※ 아래 좌표는 측량용으로 활용할 수 없습니다.
        </p>
        <Table
          $maxHeight={285}
          $cellHeight={48}
          caption={'기준점 리스트'}
          colgroup={[180, 230, 200, 200, 'auto', 140, 80]}
          thead={
            <>
              <tr>
                <th scope={'col'} rowSpan={2}>
                  지적측량기준점 종류
                </th>
                <th scope={'col'} rowSpan={2}>
                  명칭 및 번호
                </th>
                <th scope={'col'} colSpan={2}>
                  세계측지계
                </th>
                <th scope={'col'} rowSpan={2}>
                  소재지(기준점)
                </th>
                <th scope={'col'} rowSpan={2}>
                  설치일자
                </th>
                <th scope={'col'} rowSpan={2}>
                  행 삭제
                </th>
              </tr>
              <tr>
                <th scope={'col'} style={{ borderLeft: 0 }}>
                  평면직각좌표 X(m)
                </th>
                <th scope={'col'}>평면직각좌표 Y(m)</th>
              </tr>
            </>
          }
          tbody={
            <>
              {points.map((feature, index) => {
                return (
                  <tr key={index}>
                    <td>{feature.getProperties().properties.BASE_NAME}</td>
                    <td>{nameReturn(feature)}</td>
                    <td>{feature.getProperties().properties.X_CODE}</td>
                    <td>{feature.getProperties().properties.Y_CODE}</td>
                    {/*<td>{addressCodeToString(feature)}</td>*/}
                    <td>{feature.getProperties()?.properties.DTLOC}</td>
                    <td>{transYMD(feature.getProperties()?.properties.BUILD_YMD)}</td>
                    <td>
                      <Button text={'-'} $isGradientBtn={true} onClick={() => onClick(feature)} />
                    </td>
                  </tr>
                );
              })}
            </>
          }
        />
      </PopupSt.Inner>
    </PopupSt.Wrap>
  );
};

export default PopupPointList;
